/* eslint-disable no-console */
import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

@Component
export class ProductGallery extends ThemeComponent {
    @Ref data!: HTMLElement;

    init() {
        // Setup gallery image zoom/lightbox
        this.setupLightbox();
    }

    setupLightbox() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: this,
            children: '.product-gallery__media--image',
            pswpModule: PhotoSwipe
        });

        lightbox.init();
    }

}
